export default __webpack_public_path__ + "static/media/centro_lomas.c2fc9b05.jpg";